/***
 * Created on 2023/7/11
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

export async function apiGet(endpoint) {
    try {
        await getCSRFToken();
        const response = await fetch(endpoint);
        if (!response.ok) {
            const json = await response.json();
            throw new Error('Api Request Error', {
                cause: json
            });
        }
        return await response.json();
    } catch (err) {
        if (err?.cause) {
            console.log(err.cause);
        }
        throw err;
    }
}

export async function apiPost(endpoint, data, data_type='json', options={}) {
    return await _apiRequest(endpoint, data, data_type);
}

export async function apiPatch(endpoint, data, data_type='json', options={}) {
    return await _apiRequest(endpoint, data, data_type, 'PATCH');
}

export async function apiPut(endpoint, data, data_type='json', options={}) {
    return await _apiRequest(endpoint, data, data_type, 'PUT');
}

export async function apiDelete(endpoint, data, data_type='json', options={}) {
    return await _apiRequest(endpoint, data, data_type, 'DELETE');
}

async function _apiRequest(endpoint, data, data_type='json', method='POST', options={}) {
    const opts = {
        method
    }

    let csrf_token = options?.csrf_token;
    if (!csrf_token) {
        csrf_token = await getCSRFToken();
    }
    opts.headers = {
        "X-XSRF-TOKEN": csrf_token
    }
    let content_type;
    let body;
    if (data_type !== 'form-data') {
        if (data_type === 'json') {
            content_type = "application/json";
            body = JSON.stringify(data || {});
        }
        else {
            content_type = "application/x-www-form-urlencoded";
            body = new URLSearchParams(data);
        }
        if (content_type) {
            opts.headers["Content-Type"] = content_type;
        }
    }
    opts.body = body || data;

    const response = await fetch(endpoint, opts);
    if (!response.ok) {
        const err = new Error('Api Request Error');
        if (response.status === 429) {
            err.cause = {code: 1019010}
        }
        else if (response.status === 400) {
            err.cause = await response.json();
        }
        else {
            err.cause = {
                code: '1000001',
                message: await response.text()
            };
        }
        throw err;
    }
    const result = await response.json();
    return result;
}

export async function getCSRFToken() {
    try {
        const response = await fetch('/alive');
        if (!response.ok) {
            throw new Error('Api Request Error', {
                cause: response
            });
        }
        else {
            const data = await response.json();
            if (!data?.alive) {
                window.location = '/signin';
            }
        }
        return response.headers.get('x-xsrf-token');
    } catch (err) {
        if (err?.cause) {
            console.log(err.cause);
        }
        throw new Error(err);
    }

}